import React, {useEffect, useState} from 'react'
import {Col, Row} from 'react-bootstrap'
import Box from '../../component/Box/Box'
import DashboardVerticalBar from '../../component/Dashboard/DashboardVerticalBar'
import Icon from '../../component/Icon/Icon'
import LoadingV2 from '../../component/Loading/LoadingV2'
import InventoryService from '../../services/InventoryService'

function InventoryDashboard({itemsRead, inventoryId}) {
  const [isLoading, setIsLoading] = useState(false)
  const [chartOptions, setChartOptions] = useState(null)
  const [hasErrorOnLoadData, setHasErrorOnLoadData] = useState(false)
  const inventoryService = new InventoryService()
  const isReading = itemsRead && itemsRead.executionData

  const handleSummaryData = async () => {
    try {
      setHasErrorOnLoadData(false)
      setIsLoading(true)
      const summary = await inventoryService.getInventorySummary(inventoryId)
      summary.totalExpected = summary.totalNotFound + summary.totalFound
      mountDashboardData(summary)
    } catch (error) {
      setHasErrorOnLoadData(true)
    } finally {
      setIsLoading(false)
    }
  }

  const mountDashboardData = (data) => {
    const summaryData = {}
    summaryData["Esperados"] = data.totalNotFound + data.totalFound;
    summaryData["Não esperados"] = data.totalUnexpected;
    summaryData["Encontrados"] = data.totalFound;
    summaryData["Não encontrados"] = data.totalNotFound;
    summaryData["Lidos"] = data.totalUnexpected + data.totalFound;

    const chartOptions = {
      lineNames: ["Resultado"],
      colors: ['#04db7b', '#f2d52e', '#f53131'],
      data: summaryData,
      max: data.totalExpected + data.totalUnexpected,
      chartId: "Inventário",
      height: 300,
      stacked: false
    }
    setChartOptions(chartOptions)
  }

  useEffect(() => {
    if (!isReading) {
      handleSummaryData()
    } else {
      mountDashboardData(itemsRead)
    }
  }, [itemsRead]);

  const RetryComponent = () => {
    const refreshIconStyle = {
      fontSize: "2rem",
      textAlign: 'center',
      cursor: 'pointer',
      "&:hover": {
        background: 'gray'
      }
    }
    return (
      <div className="d-flex justify-content-center flex-column">
        <h3 className="text-center mb-3">Houve um erro ao carregar os dados do gráfico</h3>
        <Icon icon='refresh' onClick={handleSummaryData} style={refreshIconStyle}/>
      </div>
    )
  }

  return (
    <Box title="Dashboard">
      <Row>
        <Col md={11}>
          {
            !hasErrorOnLoadData &&
            <LoadingV2 isLoading={isLoading}>
              {chartOptions && <DashboardVerticalBar {...chartOptions} />}
            </LoadingV2>
          }
          {
            hasErrorOnLoadData &&
            <RetryComponent/>
          }
        </Col>
      </Row>
    </Box>
  )
}

export default InventoryDashboard



// WEBPACK FOOTER //
// ./src/Inventory/components/InventoryDashboard.js